import React from 'react';

import { Divider, Spin } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';

import IntlMessages from 'util/IntlMessages';

import ReportTable from '../../ReportTable';
import { mapReportData } from '../shared/mapReportData';
import styles from '../../styles.module.less';
import EmptyUserData from '../shared/EmptyUserData';
import { PATHS } from '@src/containers/App/TimeTracker/constants';

export default function ModificationsReport({
  data,
  loading = false,
  next = null,
  queriedPeriod = '',
}) {
  if (Object.keys(data).length === 0) return null;
  return (
    <>
      <div className="gx-w-100">
        <div className={styles.titleDt}>
          <IntlMessages id="work.direction.modifications.report" />
        </div>
      </div>
      <Divider />
      {loading && <Spin />}
      <div id="scrollableDiv" className={styles.scrollableDivOwnReports}>
        <InfiniteScroll
          dataLength={data?.total ?? 0}
          scrollableTarget="scrollableDiv"
          next={next}
          hasMore={data?.hasMore}
        >
          <div className="gx-pt-4">
            {Object.keys(data?.data || {})?.length === 0 && !loading && (
              <EmptyUserData reportType={PATHS.MODIFICATIONS} queriedPeriod={queriedPeriod} />
            )}
            {mapReportData(data?.data, ({ id, employee, employer, columns, source }) => (
              <React.Fragment key={id}>
                <ReportTable
                  rowKey="id"
                  data={source}
                  headerOne={employee}
                  headerTwo={employer}
                  columns={columns}
                  disableScroll={true}
                />
              </React.Fragment>
            ))}
          </div>
        </InfiniteScroll>
      </div>
    </>
  );
}
